
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kredit-gadget",
      function () {
        return require("private-next-pages/kredit-gadget.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kredit-gadget"])
      });
    }
  